export default __webpack_public_path__ + "static/media/ios-arrow-back.33f87ede.svg";